<template>
  <div id="offers">
    <div id="offers-banner">
      <section class="banner">
        <v-parallax height="990" src="@/assets/images/banner.webp">
          <v-row justify="center">
            <v-col class="text-center" cols="12" sm="12" md="12" lg="12">
              <div>
                <v-row justify="center">
                  <v-col cols="12" sm="12" md="12" lg="12" class="pa-0 ma-0">
                    <h1 class="banner__title">Trabajos que cambian el mundo</h1>
                  </v-col>
                  <v-col cols="8" sm="9" md="9" lg="8">
                    <p class="banner__text">
                      Acá escribimos y compartimos de los trabajos que cambian el mundo, de lo que nos motiva y nos apasiona. Impulsar y promover el
                      ecosistema social, de innovación y emprendimiento de Latinoamérica es nuestra pasión.
                      Nos une trabajar por un propósito.
                    </p>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row class="my-15 py-6" justify="center" >
            <PostList :items="items" :feed="feed"/>
          </v-row>
        </v-parallax>
      </section>
    </div>
  </div>
</template>

<script>
import PostList from "@/components/PostList";
import { meta } from "@/libs/mixins";

export default {
    name: "Blog",

    components: { PostList },

    props: ["feed", "items"],

    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Trabajo con Sentido",
        });
    },

    data() {
        return {
            posts: [],
            posts_desc: [],
            url: ""
        };
    },

    created() {
        this.url = this.feed.link;
    },

    methods: {
        destructuring(text) {
            return text;
        },
    }
};
</script>
